import { render, staticRenderFns } from "./ReferralNote.vue?vue&type=template&id=7cd66f64&"
import script from "./ReferralNote.vue?vue&type=script&lang=js&"
export * from "./ReferralNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports